import React, { useEffect, useState } from "react";
import { Box, Checkbox, Grid, FormControlLabel, Tooltip, Typography } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';

interface PaymentTypeConfigProps {
    name: string,
    label: string,
    description: string,
    value?: Array<string>,
    onChange: (ConfigTypeKey: string, AssignedValue: any) => void,
}

const BlankIcon = <Box sx={{ width: '9px', height: '9px', backgroundColor: '#C4C4C4' }}></Box>;
const CheckedIcon = <Box sx={{ width: '9px', height: '9px', backgroundColor: '#39A2DB' }}></Box>;
const LabelText = (label: string) => (
    <Typography 
        sx={{ 
            fontFamily: 'Work Sans',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '22px',
        }}
        >
        {label}
    </Typography>
)

interface ConfigStateType {
    [key: string]: boolean
}

export default function PaymentTypeConfig({
    name,
    label,
    description,
    value,
    onChange,
}: PaymentTypeConfigProps) {
    const [configState, setConfigState] = useState<ConfigStateType>({
        ach: false,
        db: false,
        cc: false,
    });

    useEffect(() => {
        setConfigState({
            ach: value?.includes("ACH") ?? false,
            db: value?.includes("DB") ?? false,
            cc: value?.includes("CC") ?? false,
        });
    }, [value])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, configTypeKey?: string) => {
        const newState = {
            ...configState,
            [event.target.name]: event.target.checked
        }
        setConfigState(newState);

        const newValue: Array<string> = [];
        if (newState.ach) newValue.push('ACH');
        if (newState.db) newValue.push('DB');
        if (newState.cc) newValue.push('CC');

        onChange(name, newValue);
    };

    const checkboxControl = (name: string, checked: boolean) => (
        <Checkbox
            name={name}
            checked={checked}
            onChange={(event) => handleChange(event)}
            icon={BlankIcon}
            checkedIcon={CheckedIcon}
        />
    )

    return (
        <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title={description} placement="right">
                    <HelpIcon sx={{ fontSize: 16, color: "#C4C4C4", cursor: "pointer", mr: '9px' }} />
                </Tooltip>

                {LabelText(label)}
            </Grid>

            <Grid item xs={12} sx={{ 
                display: 'flex', 
                alignItems: 'center',
                ml: 2,
                my: 1,
            }}>
                <FormControlLabel 
                    control={checkboxControl('ach', configState.ach)}
                    label={LabelText('ACH')}
                />
                <FormControlLabel 
                    control={checkboxControl('db', configState.db)}
                    label={LabelText('Debit')}
                />
                <FormControlLabel 
                    control={checkboxControl('cc', configState.cc)}
                    label={LabelText('Credit')}
                />
            </Grid>
        </Grid>
    );
}
